import React from "react";
import Tooltip from "storybookComponents/Tooltip2";
import Typography from "@material-ui/core/Typography";

export const RightContent = ({ classes, list }) => (
  <Typography className={classes.rightContent} noWrap>
    {list.length > 0 ? (
      list.length === 1 ? (
        list[0]
      ) : (
        <>
          {list[0]},{" "}
          <Tooltip
            position="bottom"
            text={
              <div>
                {list
                  .filter((i, idx) => idx > 0)
                  .map((i, idx) => (
                    <div key={idx}>{i}</div>
                  ))}
              </div>
            }
          >
            <span>+{list.length - 1}</span>
          </Tooltip>
        </>
      )
    ) : (
      <span className={classes.emptyStyle}>None</span>
    )}
  </Typography>
);

export default RightContent;
